import React, { createContext, useContext, useState } from "react";
import { EXTRA_PATHS, ROLE_PATHS } from "../../config/config";
import { soulManager } from "../managers/SoulManager";
import { SoulDataModel } from "../models/Soul/SoulDataModel";

export interface UserDataContextType {
  data?: SoulDataModel;
  permittedPaths: string[];
  reloadUserData: () => Promise<void>;
}

const UserDataContext = createContext<UserDataContextType | undefined>(
  undefined
);

export const UserDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [userData, setUserData] = useState<SoulDataModel>();
  const [permittedPaths, setPermittedPaths] = useState<string[]>([]);

  async function getUserData() {
    const data = await soulManager.getSoul();
    setUserData(data);
    const role = (data?.role?.toUpperCase() ||
      "USER") as keyof typeof ROLE_PATHS;
    const permittedPaths = ROLE_PATHS[role] ?? [];
    let extraPaths: string[] = [];
    if (data?.role === "USER" && data.isParentAccount) {
      extraPaths = EXTRA_PATHS[role];
    }
    setPermittedPaths([...permittedPaths, ...extraPaths]);
  }

  const value: UserDataContextType = {
    data: userData,
    permittedPaths,
    reloadUserData: getUserData,
  };

  return (
    <UserDataContext.Provider value={value}>
      {children}
    </UserDataContext.Provider>
  );
};

export function useUserData() {
  return useContext(UserDataContext);
}
